import axios from 'axios'
import Vue from 'vue'
import Auth from 'ms-auth'
import store from '@/store'

Vue.use(Auth)

const auth = new Auth({
  ssKey: `hydra-ship-v-${String(process.env.VUE_APP_COMPANY).snakeCase()}-${process.env.NODE_ENV[0]}`,
  token: 'token',
  currentUserUrl: process.env.VUE_APP_API_URL + '/registrations',
  authorizationStr: 'Token token={{token}};email={{email}}'
})

auth.isCust = function () {
  return this.currentUser.user_type === 'customer'
}

auth.isOper = function () {
  return this.currentUser.user_type === 'operator'
}

auth.isAdmin = function () {
  return this.currentUser.user_type === 'admin'
}

auth.isMainAdmin = function () {
  const mainAdminRole = this.currentUser.user_type === 'main_admin'
  const mainAdminFlag = this.currentUser.user_type === 'admin' && this.currentUser.is_main_admin
  return mainAdminRole || mainAdminFlag
}

auth.isDev = function () {
  return this.currentUser.user_type === 'developer'
}

auth.getCurrentUser = async function () {
  if (!auth.accessToken) {
    console.log('No AccessToken')
    auth.setCurrentUser({})
    return
  }

  const { data } = await axios.get(process.env.VUE_APP_API_URL + '/registrations', {
    headers: { Authorization: auth.accessToken }
  })
  auth.setCurrentUser(data.data)
  if(data.data.id) store.state.currentUser = data.data
}

auth.getAcls = async function () {
  const { data } = await axios.get(process.env.VUE_APP_API_URL + '/acls', {
    headers: { Authorization: auth.accessToken }
  })
  const acls = data.data
  const can = acls.can

  auth.addRule('Dashboard', 'read')
  if (can.manage) {
    if (can.manage.hasOwnProperty('all')) {
      auth.addRule('manage', 'all')
    } else if (Array.isArray(can.manage) && can.manage.includes('all')) {
      auth.addRule('manage', 'all')
    } else {
      const models = Object.keys(can.manage)
      for (let model of models) {
        auth.addRule(model, 'read')
        auth.addRule(model, 'create')
        auth.addRule(model, 'update')
        auth.addRule(model, 'destroy')
      }
    }
  }

  if (this.isAdmin() || this.isMainAdmin()) {
    auth.addRule('Report', 'read')
    auth.addRule('Report', 'create')
    auth.addRule('Report', 'update')
    auth.addRule('Report', 'destroy')
    auth.addRule('ManualShipment', 'read')
    auth.addRule('ManualShipment', 'create')
  }

  if (can.read) {
    if (Array.isArray(can.read)) {
      can.read.forEach(model => auth.addRule(model, 'read'))
    } else {
      const keys = Object.keys(can.read)
      for (let key of keys) {
        auth.addRule(key, 'read')
      }
    }
  }
  if (can.index) {
    if (Array.isArray(can.index)) {
      can.index.forEach(model => auth.addRule(model, 'read'))
    } else {
      const keys = Object.keys(can.index)
      for (let key of keys) {
        auth.addRule(key, 'read')
      }
    }
  }

  if (can.create) {
    if (Array.isArray(can.create)) {
      can.create.forEach(model => auth.addRule(model, 'create'))
    } else {
      const keys = Object.keys(can.create)
      for (let key of keys) {
        auth.addRule(key, 'create')
      }
    }
  }

  if (can.update) {
    if (Array.isArray(can.update)) {
      can.update.forEach(model => auth.addRule(model, 'update'))
    } else {
      const keys = Object.keys(can.update)
      for (let key of keys) {
        auth.addRule(key, 'update')
      }
    }
  }

  if (can.destroy) {
    if (Array.isArray(can.destroy)) {
      can.destroy.forEach(model => auth.addRule(model, 'destroy'))
    } else {
      const keys = Object.keys(can.destroy)
      for (let key of keys) {
        auth.addRule(key, 'destroy')
      }
    }
  }
}

export default auth
